// sources for media
export default [
    'Free',
    'TASS',
    'AP',
    'Sputnik',
    'AFP',
    'Reuters',
    'Global Look Press',
    'Getty Images',
    'Vostock-Photo',
    'Legion Media',
]
